import { useContext } from 'react';
import { InstagramEmbed } from 'react-social-media-embed';

import styles from '../../article.module.css';

export const VirtualInstagram = (props: InstagramProps) => {
	const { id, bleed, params } = props;
	const { type, videoID } = params;

	const className = [styles['instagram'], 'media', 'instagram'];

	if (bleed) {
		className.push('bleed');
	}

	if (!type || !videoID) {
		return null;
	}

	let url = '';
	switch (type) {
		case 'tv':
		case 'reel':
			url = `https://www.instagram.com/${type}/${videoID}/`;
			break;
		default:
			url = `https://www.instagram.com/p/${videoID}/`;
			break;
	}

	return (
		<div id={id} className={className.join(' ')}>
			<InstagramEmbed url={url} width={328} />
		</div>
	);
};

interface InstagramProps {
	id: string;
	bleed: boolean;
	language: string;
	params: Params;
}

interface Params {
	type: 'post' | 'reel' | 'tv';
	videoID: string;
}
